declare global {
  interface Window {
    AndroidBridge?: {
      shareText?: (text: string, url?: string) => void;
      openExternal?: (url: string) => void;
      vibrate?: (durationMs?: number) => void;
      getPlatform?: () => string;
    };
  }
}

export const isAndroidWebView = () => {
  return typeof window !== 'undefined' && !!window.AndroidBridge;
};

export const shareWithNativeFallback = async ({
  title,
  text,
  url,
}: {
  title?: string;
  text?: string;
  url: string;
}) => {
  const bridge = typeof window !== 'undefined' ? window.AndroidBridge : undefined;

  if (bridge?.shareText) {
    bridge.shareText(text || title || url, url);
    return true;
  }

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ title, text, url });
      return true;
    } catch (error: any) {
      if (error?.name === 'AbortError') return true;
      console.warn('Native share failed. Falling back to clipboard.', error);
    }
  }

  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(url);
      return true;
    } catch (error) {
      console.warn('Clipboard share fallback failed.', error);
    }
  }

  return false;
};

export const vibrateNative = (durationMs = 35) => {
  if (typeof window === 'undefined') return;
  window.AndroidBridge?.vibrate?.(durationMs);
};

export const openExternalUrl = (url: string) => {
  if (typeof window === 'undefined') return;
  window.AndroidBridge?.openExternal?.(url);
};
